import React from 'react';
import CostcoLocationTemplate from '../../components/CostcoLocationTemplate';

const Canberra = () => (
  <CostcoLocationTemplate
    warehouseName="Canberra Airport"
    suburb="Majura Park"
    state="Australian Capital Territory"
    stateShort="ACT"
    address="Mustang Ave, Majura Park ACT 2609"
    path="/costco/canberra"
    nearbySuburbs={[
      'Majura Park',
      'Pialligo',
      'Campbell',
      'Russell',
      'Kingston',
      'Fyshwick',
      'Queanbeyan',
      'Jerrabomberra',
      'Canberra City',
      'Braddon',
    ]}
    description="Manage Your Loans is the exclusive Costco member loan partner serving the Canberra Airport warehouse at Majura Park and the wider ACT and Queanbeyan region. Whether you're a government employee looking to buy your first home, refinancing an existing property, or investing across the ACT-NSW border, our brokers can help you earn Costco Shop Card rewards on settled loans."
    localContext={[
      'Canberra\'s property market is underpinned by stable government employment and high household incomes, creating consistent demand for quality homes across the ACT.',
      'The ACT-NSW border region — including Queanbeyan and Jerrabomberra — offers more affordable alternatives to inner Canberra while maintaining easy access to employment hubs.',
      'Government employee lending is a specialised area, with many lenders offering competitive rates for permanent public servants and defence personnel based in the ACT.',
    ]}
    faqs={[
      {
        q: 'How do I claim my Costco Shop Card at the Canberra warehouse?',
        a: 'Apply for a loan through Manage Your Loans as a Costco Executive Member. Once your loan settles, we\'ll arrange your Shop Card reward. You can use it at the Canberra Airport warehouse or any Costco in Australia.',
      },
      {
        q: 'Do you offer specialised lending for government employees?',
        a: 'Yes. Many lenders on our panel offer competitive rates and favourable terms for permanent government employees and defence personnel. Our brokers can help you access these products and earn your Costco Shop Card reward.',
      },
      {
        q: 'Can I buy in Queanbeyan and still use the Costco Canberra service?',
        a: 'Absolutely. Our service covers the entire ACT and surrounding NSW regions including Queanbeyan, Jerrabomberra, and beyond. Queanbeyan offers more affordable entry points while being just minutes from Canberra.',
      },
      {
        q: 'What types of loans are available for Costco members in the ACT?',
        a: 'We offer home loans, refinancing, investment property loans, car loans, personal loans, and asset finance. All eligible settled loans earn Costco Shop Card rewards for Executive Members.',
      },
    ]}
    suburbData={{
      suburb: 'Campbell',
      medianHouse: '$1,350,000',
      medianUnit: '$580,000',
      daysOnMarket: '28 days',
      rentalYield: '3.0%',
      population: '5,200',
      distanceToCostco: '3 km',
    }}
    surroundingSuburbs={[
      { suburb: 'Kingston', medianHouse: '$1,450,000', medianUnit: '$580,000', daysOnMarket: '26 days' },
      { suburb: 'Fyshwick', medianHouse: '$950,000', medianUnit: '$480,000', daysOnMarket: '30 days' },
      { suburb: 'Queanbeyan', medianHouse: '$780,000', medianUnit: '$450,000', daysOnMarket: '28 days' },
      { suburb: 'Jerrabomberra', medianHouse: '$920,000', medianUnit: '$520,000', daysOnMarket: '25 days' },
      { suburb: 'Canberra City', medianHouse: '$1,500,000', medianUnit: '$600,000', daysOnMarket: '24 days' },
      { suburb: 'Braddon', medianHouse: '$1,200,000', medianUnit: '$560,000', daysOnMarket: '23 days' },
      { suburb: 'Russell', medianHouse: '$1,380,000', medianUnit: '$570,000', daysOnMarket: '27 days' },
      { suburb: 'Pialligo', medianHouse: '$1,100,000', medianUnit: '$520,000', daysOnMarket: '32 days' },
    ]}
  />
);

export default Canberra;
